import { createContext } from "react";

export const PatientContext = createContext();